import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { NavItems } from "./NavItems";

interface DesktopNavProps {
  onLogin: () => void;
  onGetStarted: () => void;
}

export const DesktopNav = ({ onLogin, onGetStarted }: DesktopNavProps) => {
  return (
    <>
      <nav className="hidden md:flex gap-8">
        <NavItems />
      </nav>

      <div className="hidden md:flex items-center gap-4">
        <Button variant="ghost" onClick={onLogin} className="min-h-[44px]">
          Login
        </Button>
        <Button onClick={onGetStarted} className="min-h-[44px]">
          Get Started <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </>
  );
};